import styled from 'styled-components';
import {StyledSuggestionTag} from '../../ExpensesPage/SuggestionPopover/StyledSuggestionPopover';

const StyledAgentChatSuggestionTag = styled(StyledSuggestionTag)`
  border-color: ${props => props.theme.colors.additional_purple};

  &:hover {
    border-color: ${props => props.theme.colors.additional_purple};
  }
`;

export {
  StyledAgentChatSuggestionTag
}
